import { Button, Checkbox, Col, Divider, Form, Input, Radio, Row } from "antd";
import React from "react";
import { getMappedData } from "../util";

export default function Feedback() {
  return (
    <>
      {/*<Row gutter={[24, 0]}>*/}
      {/*  <Col xs={24} xl={24}>*/}
      {/*    <Form.Item name="feedback_ack_1" valuePropName="checked">*/}
      {/*      <Checkbox value="feedback_ack_1_value">*/}
      {/*        {getMappedData('feedback_ack_1')}*/}
      {/*      </Checkbox>*/}
      {/*    </Form.Item>*/}
      {/*  </Col>*/}
      {/*</Row>*/}
      <Row gutter={[24, 0]}>
        {/*<Col xs={24} xl={24}>*/}
        {/*  <Form.Item name="feedback_ack_2" valuePropName="checked">*/}
        {/*    <Checkbox value="feedback_ack_2_value">*/}
        {/*      {getMappedData('feedback_ack_2')}*/}
        {/*    </Checkbox>*/}
        {/*  </Form.Item>*/}
        {/*</Col>*/}
        <Col xs={24} xl={24}>
            <Form.Item
              name="feedback_ack_2_description"
              label="Explain your observation"
              rules={[{ required: true, message: "Please specify" }]}
            >
              <Input.TextArea rows={14} placeholder="Enter your answers here" />
            </Form.Item>
          </Col>
      </Row>
      {/*<Row gutter={[24, 0]}>*/}
      {/*  <Col xs={24} xl={24}>*/}
      {/*    <Form.Item name="feedback_ack_3" valuePropName="checked">*/}
      {/*      <Checkbox value="feedback_ack_3_value">*/}
      {/*        {getMappedData('feedback_ack_3')}*/}
      {/*      </Checkbox>*/}
      {/*    </Form.Item>*/}
      {/*  </Col>*/}
      {/*  <Col xs={24} xl={24}>*/}
      {/*      <Form.Item*/}
      {/*        name="feedback_ack_3_description"*/}
      {/*        label="Explain"*/}
      {/*        rules={[{ required: true, message: "Please specify" }]}*/}
      {/*      >*/}
      {/*        <Input.TextArea rows={4} placeholder="Enter your answers here" />*/}
      {/*      </Form.Item>*/}
      {/*    </Col>*/}
      {/*</Row>*/}
      {/*<Row gutter={[24, 0]}>*/}
      {/*  <Col xs={24} xl={24}>*/}
      {/*      <Form.Item*/}
      {/*        name="feedbackOtherNotes"*/}
      {/*        label="Detail of the date and place of Incident"*/}
      {/*        rules={[{ required: true, message: "Please specify" }]}*/}
      {/*      >*/}
      {/*        <Input.TextArea rows={10} placeholder="Enter your answers here" />*/}
      {/*      </Form.Item>*/}
      {/*    </Col>*/}
      {/*</Row>*/}
    </>
  );
}
